import React, { FC } from "react";
import styled from 'styled-components';
import { ALink } from "../utility/link";
type Props = {
  text: string,
  leftWord: string,
  leftLinkPath: string,
  rightWord: string,
  rightLinkPath: string,
  positionSticky?: boolean;
  backgroundColor?: string;
}

export const PageTitleWithDubbleLink:FC<Props> = (props: Props) => {
  const { text, leftLinkPath, leftWord, rightWord, rightLinkPath, positionSticky = true, backgroundColor = 'white' } = props;

  const position = () => {
    if(positionSticky) {
      return 'sticky'
    } else {
      return 'static'
    }
  };

  return(
    <>
      <DivTitleWrap style={{position: position(), backgroundColor: backgroundColor}}>
        <DivLeft>
          <ALink href={leftLinkPath}>
            {leftWord}
          </ALink>
        </DivLeft>
        <DivH1TileWrap>
          <H1Tile>
            { text }
          </H1Tile>
        </DivH1TileWrap>
        <DivRight>
          <ALink href={rightLinkPath}>
            {rightWord}
          </ALink>
          </DivRight>
      </DivTitleWrap>
    </>
  )
}

const DivTitleWrap = styled.div`
  padding: 1rem;
  border-bottom: 1px solid #b5b4b4;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const DivH1TileWrap = styled.div`
  font-size: 1.25rem;
  padding: 0 0.5rem;
  flex: 1;
  display: flex;
  justify-content: center;
`

const H1Tile = styled.h1`
  text-align: center;
  display: inline-block;
  text-align: left;
  font-size: 1.25rem;
`

const DivRight = styled.div`
`

const DivLeft = styled.div`
`
